import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { PageEvent } from '@targx/components/pagination/pagination.definition';
import { switchMap } from 'rxjs';
import { DealerSearchService } from '../../dealer-search.service';
import { DealerDataService } from '../../dealer-data.service';

@Component({
  selector: 'ade-pesquisa',
  templateUrl: './pesquisa.component.html',
  styleUrls: ['./pesquisa.component.scss'],
})
export class AdePesquisaComponent implements OnInit {
  isLoading = true;
  products: Data[] = [];
  numFound = 0;

  searchQuery = '';
  searchSort = 'published_at_dt desc';

  page: PageEvent = {
    pageIndex: 1,
    pageSize: 24,
    length: 0,
  };

  constructor(
    private _svc: DealerSearchService,
    private _dataSvc: DealerDataService,
    private _route: ActivatedRoute,
    private _router: Router,
  ) {}

  ngOnInit(): void {
    this.searchQuery = this._route.snapshot.queryParams?.s || '';
    this.page.pageIndex = Number(this._route.snapshot.queryParams?.page) || 1;
    this._findProducts();
  }

  private _resetPage(): void {
    this.page = { pageIndex: 1, pageSize: 24, length: 0 };
  }

  private _findProducts(): void {
    this.isLoading = true;
    this._svc
      .searchSolr(
        this.searchQuery,
        this.page.pageIndex - 1,
        this.page.pageSize,
        this.searchSort,
      )
      .pipe(
        switchMap((res: Data) => {
          this.numFound = res.numFound;
          const ids = res.products.map((p: Data) => p.id);
          return this._dataSvc.getProductsByIds(ids);
        }),
      )
      .subscribe({
        next: (res: Data) => {
          this.products = res.data;
          this.isLoading = false;
        },
        error: () => {
          this.products = [];
          this.numFound = 0;
          this.isLoading = false;
        },
      });
  }

  onSearch(query: string): void {
    this._resetPage();
    this.searchQuery = query;
    this._findProducts();

    this._router.navigate(['./'], {
      queryParams: { s: this.searchQuery, page: this.page.pageIndex },
      queryParamsHandling: 'merge',
      relativeTo: this._route,
    });
  }

  handlePageEvent(e: PageEvent): void {
    this.page = e;
    this._router.navigate(['./'], {
      queryParams: { s: this.searchQuery, page: e.pageIndex },
      queryParamsHandling: 'merge',
      relativeTo: this._route,
    });
    this._findProducts();
  }

  get pageCount(): number {
    return Math.max(1, Math.ceil(this.numFound / this.page.pageSize));
  }

  goToPage(pageIndex: number): void {
    if (
      pageIndex < 1 ||
      pageIndex > this.pageCount ||
      pageIndex === this.page.pageIndex
    )
      return;
    this.handlePageEvent({ ...this.page, pageIndex });
  }
}
